exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root {\n\n  /*colors named by https://www.color-blindness.com/color-name-hue/*/\n\n  /*shadow*/\n\n  /*z-index*/\n\n  /*transition*/\n\n  /*radius*/\n\n  /*chat*/\n}\n\n._27O-Ivd {\n  position: relative;\n}\n\n._3Y-Tiez {\n  line-height: 1;\n  font-size: 28px;\n  font-weight: 600;\n  margin: 0 0 20px;\n    text-align: center;\n  }\n\n.zk5qz1o {\n    text-align: center;\n    color: #707579;\n    white-space: pre-line;\n    margin: 0 0 45px;\n  }\n", ""]);
// Exports
exports.locals = {
	"AuthStep": "_27O-Ivd",
	"AuthStep__title": "_3Y-Tiez",
	"AuthStep__text": "zk5qz1o"
};